"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTriangleDown = void 0;
const react_1 = __importDefault(require("react"));
exports.IconTriangleDown = react_1.default.memo(() => {
    return (react_1.default.createElement("svg", { "data-selector-id": "icon-triangle-down", width: "16", height: "16", viewBox: "0 0 16 16" },
        react_1.default.createElement("path", { d: "M8 8L16 16H0L8 8Z", fill: "currentColor" })));
});
exports.IconTriangleDown.displayName = 'IconTriangleDown';
//# sourceMappingURL=IconTriangleDown.js.map